import React, { useEffect, useState } from "react";
import { adminApi, fmtINR } from "../../lib/api";

export default function AdminRedemptions() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        adminApi.get("/api/admin/redemptions").then((r) => setItems(r.data.redemptions));
    }, []);

    return (
        <div>
            <h1 className="font-display text-3xl font-bold">Redemptions</h1>
            <div className="fx-card mt-5 overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="text-left text-xs uppercase tracking-widest text-[#9ca3af] border-b border-[rgba(11,20,55,0.10)]">
                        <tr>
                            <th className="px-4 py-3">When</th>
                            <th className="px-4 py-3">Reward</th>
                            <th className="px-4 py-3">Value</th>
                            <th className="px-4 py-3">Points</th>
                            <th className="px-4 py-3">Cash</th>
                            <th className="px-4 py-3">Status</th>
                            <th className="px-4 py-3">Voucher</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((r) => (
                            <tr key={r.id} className="border-b border-[rgba(11,20,55,0.05)] hover:bg-white/[0.03]">
                                <td className="px-4 py-3 text-xs text-[#6b7280]">
                                    {new Date(r.created_at).toLocaleString("en-IN")}
                                </td>
                                <td className="px-4 py-3">{r.brand_name}</td>
                                <td className="px-4 py-3">₹{r.denomination}</td>
                                <td className="px-4 py-3 text-[#c9a959]">{r.points_used}</td>
                                <td className="px-4 py-3">{fmtINR(r.cash_paid_paise)}</td>
                                <td className="px-4 py-3">
                                    <span
                                        className={`fx-chip ${
                                            r.status === "issued"
                                                ? "bg-[#c9a959]/15 text-[#c9a959] border border-[#c9a959]/30"
                                                : "bg-[#f9fafb] text-[#4b5563] border border-[rgba(11,20,55,0.10)]"
                                        }`}
                                    >
                                        {r.status}
                                    </span>
                                </td>
                                <td className="px-4 py-3 font-mono text-xs">{r.voucher_code || "—"}</td>
                            </tr>
                        ))}
                        {items.length === 0 && (
                            <tr>
                                <td colSpan={7} className="text-center text-[#9ca3af] py-10">
                                    No redemptions yet
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
